import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loader2 } from 'lucide-react';

/**
 * PublicRoute - Wrapper per route pubbliche (landing, login, register)
 * Se l'utente è già autenticato, reindirizza alla dashboard.
 *
 * Eccezione: se nella URL ci sono i parametri SSO (`redirect` + `return_url`),
 * lasciamo passare la pagina anche se l'utente è autenticato. Login.jsx
 * gestirà il SSO automaticamente (genera token e ridirige al servizio chiamante).
 * Questo evita che un utente con JWT residuo da suite.doid.it venga sbattuto
 * sulla dashboard ignorando il flow SSO appena richiesto da menu/review/page.
 */
export default function PublicRoute({ children, redirectTo = '/dashboard' }) {
  const { isAuthenticated, loading } = useAuth();
  const [searchParams] = useSearchParams();

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-primary-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-500">Caricamento...</p>
        </div>
      </div>
    );
  }

  // Se ci sono parametri SSO nella URL, lascia che Login.jsx gestisca il flow,
  // anche se l'utente è già autenticato.
  const hasSsoParams = searchParams.get('redirect') && searchParams.get('return_url');

  // Utente autenticato senza SSO pending -> redirect alla dashboard
  if (isAuthenticated && !hasSsoParams) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
